module.exports = __webpack_public_path__ + "static/esi-logo-345ddaae01d4444b21ce550e5613f6a2.png";